import {Box, Card, Grid, Skeleton} from '@mui/material';

const IimjobsJobDetailSkeleton = () => (
  <Grid container spacing={3}>
    <Grid item xxs={12} md={8.5} lg={8.8}>
      <Card sx={{borderRadius: 4, p: 2}}>
        <Box display="flex" gap={2} alignItems="flex-start">
          <Skeleton
            variant="rounded"
            width={50}
            height={50}
            sx={{borderRadius: 1, flexShrink: 0}}
          />
          <Box flex={1}>
            <Skeleton height={26} width="72%" sx={{mb: 0.5}} />
            <Skeleton height={18} width="48%" sx={{mb: 0.25}} />
            <Skeleton height={16} width="32%" />
          </Box>
        </Box>
        <Box display="flex" gap={0.75} flexWrap="wrap" mt={1.5}>
          {[70, 100, 60, 80, 65, 85, 55, 75].map((w, i) => (
            <Skeleton
              key={i}
              variant="rounded"
              height={16}
              width={w}
              sx={{borderRadius: 1}}
            />
          ))}
        </Box>
        <Box display="flex" gap={2} mt={2}>
          <Skeleton
            variant="rounded"
            height={16}
            width={100}
            sx={{borderRadius: 1}}
          />
          <Skeleton
            variant="rounded"
            height={16}
            width={80}
            sx={{borderRadius: 1}}
          />
        </Box>
      </Card>
      <Card sx={{borderRadius: 4, mt: 2, p: 2.5}}>
        {[
          100, 100, 70, 100, 100, 55, 100, 100, 80, 100, 100, 65, 100, 90, 100,
          100, 60, 100, 100, 75, 100, 100, 50, 100, 100, 85, 100, 70, 100, 100,
          55, 100, 100, 80, 100, 65, 100, 90, 100, 100,
        ].map((w, i) => (
          <Skeleton key={i} height={15} width={`${w}%`} sx={{mb: 0.75}} />
        ))}
      </Card>
    </Grid>
    <Grid item xxs={12} md={3.5} lg={3.2}>
      <Card sx={{borderRadius: 2, p: 2, mb: 2}}>
        <Skeleton height={14} width="40%" sx={{mb: 1.5}} />
        <Box display="flex" gap={1.5} alignItems="center" mb={1.5}>
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            sx={{flexShrink: 0}}
          />
          <Box flex={1}>
            <Skeleton height={16} width="70%" sx={{mb: 0.5}} />
            <Skeleton height={13} width="85%" sx={{mb: 0.25}} />
            <Skeleton height={12} width="50%" />
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-around" mb={1.5}>
          {[0, 1, 2].map(i => (
            <Box key={i} textAlign="center">
              <Skeleton height={24} width={32} sx={{mx: 'auto', mb: 0.5}} />
              <Skeleton height={11} width={60} />
            </Box>
          ))}
        </Box>
        <Skeleton height={36} sx={{borderRadius: 1, mb: 1.5}} />
        <Skeleton height={14} width="55%" sx={{mb: 0.25}} />
        <Skeleton height={13} width="40%" sx={{mb: 1.5}} />
        <Skeleton height={14} width="45%" sx={{mb: 0.25}} />
        <Skeleton height={13} width="30%" />
      </Card>
      <Card sx={{borderRadius: 2, p: 2}}>
        <Skeleton height={14} width="55%" sx={{mb: 1.5}} />
        <Skeleton variant="rounded" height={180} sx={{borderRadius: 1}} />
      </Card>
    </Grid>
  </Grid>
);

export default IimjobsJobDetailSkeleton;
